import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Typography from '@material-ui/core/Typography'
import FormControl from '@material-ui/core/FormControl'
import InputLabel from '@material-ui/core/InputLabel'
import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'
import Box from '@material-ui/core/Box'
import { isRecurringPayment } from 'utils/groupEventUtils'
import { useStyles } from '../styles'

const EventLocation = ({ event, coachFacilities }) => {
  const { errors, control } = useFormContext()
  const classes = useStyles()

  return (
    <Box className={classes.fieldGroup}>
      <Typography className={classes.sectionHeading}>Facility</Typography>
      <Typography className={classes.fieldHelper}>
        Select where this event will be held.
      </Typography>
      <FormControl
        error={!!errors.locationId}
        variant="outlined"
        fullWidth
        className={classes.fieldInput}
      >
        <InputLabel id="edit-event-location-label">Facility</InputLabel>
        <Controller
          as={
            <Select
              labelId="edit-event-location-label"
              label="Facility"
              value=""
              data-cy="location"
              readOnly={isRecurringPayment(event)}
            >
              {coachFacilities.map(opt => (
                <MenuItem key={opt.id} value={opt.id}>
                  {opt.name}
                </MenuItem>
              ))}
            </Select>
          }
          name="locationId"
          control={control}
        />
      </FormControl>
      {errors.locationId ? (
        <Typography variant="caption" color="error">
          Please select a location
        </Typography>
      ) : null}
    </Box>
  )
}

export default EventLocation
